import './App.scss';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {ThemeProvider} from "@mui/material";
import jetTheme from "./components/themes/JetTheme";

import NotFound from "./pages/404";
import Login from "./pages/authentication/Login";
import ChangePassword from "./pages/authentication/ChangePassword";
import {AuthProvider} from "./context/AuthContext";
import {ConfigProvider} from "./context/ConfigContext";
import PrivateRoute from "./utils/PrivateRoute";


import {ErrorProvider} from "./context/ErrorContext";
import Controlling from "./pages/controlling/Controlling";
import Reports from "./pages/reports/Reports";
import Report from "./pages/reports/Report";
import ControllingItemNumber from "./pages/controlling/ControllingItemNumber";
import ControllingDetail from "./pages/controlling/ControllingDetail";
import Commission from "./pages/commission/Commission";
import CommissionDetail from "./pages/commission/CommissionDetail";
import ControllingMain from "./pages/controllingMain/ControllingMain";
import EmployeeEffectivenessDetail from "./pages/employee/EmployeeEffectivenessDetail";
import EmployeeEffectiveness from "./pages/employee/Effectiveness";
import PartnerEffectiveness from "./pages/partner/PartnerEffectiveness";
import PartnerEffectivenessDetail from "./pages/partner/PartnerEffectivenessDetail";
import PartnerCompare from "./pages/partner/PartnerCompare";
import PartnerTrafficEffectiveness from "./pages/partnerTraffic/PartnerEffectiveness";
import PartnerTrafficEffectivenessDetail from "./pages/partnerTraffic/PartnerEffectivenessDetail";
import FinishedReports from "./pages/finishedReports/FinishedReports";
import TicketReport from "./pages/finishedReports/ticketReport/TicketReport";
import SavedCommissions from "./pages/commission/SavedCommission";
import SavedCommissionDetail from "./pages/commission/SavedCommissionDetail";
import SelectView from "./pages/partner/SelectView";
import CompanyGroups from "./pages/partner/companyGroups/CompanyGroups";
import CompanyGroupDetail from "./pages/partner/companyGroups/CompanyGroupDetail";
import GroupCompare from "./pages/partner/companyGroups/GroupCompare";
import Home from "./pages/home/Home";


function App() {

  return <ThemeProvider theme={jetTheme}>
    <ConfigProvider>
      <ErrorProvider>
        <Router>
          <AuthProvider>
            <Switch>
              <PrivateRoute path="/" component={Home} resource={null} exact/>
              <PrivateRoute path="/controlling" component={Controlling} exact resource='generalLedgerAnalytics'/>
              <PrivateRoute path="/item-number" component={ControllingItemNumber} resource='generalLedgerAnalytics' exact/>
              <PrivateRoute path="/item-number/:slug" component={ControllingDetail} resource='generalLedgerAnalytics' exact/>
              <PrivateRoute path="/report" component={Reports} resource='report' exact/>
              <PrivateRoute path="/finished-report" component={FinishedReports} resource='report' exact/>
              <PrivateRoute path="/report/:id" component={Report} resource='report' exact/>
              <PrivateRoute path="/ticket-report" component={TicketReport} resource='report' exact/>
              <PrivateRoute path="/commission" component={Commission} resource='customUser' exact/>
              <PrivateRoute path="/commission/:id" component={CommissionDetail} resource='customUser' exact/>
              <PrivateRoute path="/saved-commissions" component={SavedCommissions} resource='savedCommission' exact/>
              <PrivateRoute path="/saved-commission/:id" component={SavedCommissionDetail} resource='savedCommission' exact/>
              <PrivateRoute path="/controlling-main" component={ControllingMain} resource='generalLedgerAnalytics' exact/>
              <PrivateRoute path="/select-view" component={SelectView} resource='generalLedgerAnalytics' exact/>
              <PrivateRoute path="/employee-effectiveness" component={EmployeeEffectiveness} resource='generalLedgerAnalytics' exact/>
              <PrivateRoute path="/company-groups" component={CompanyGroups} resource='companyGroup' exact/>
              <PrivateRoute path="/company-groups/:id" component={CompanyGroupDetail} resource='companyGroup' exact/>
              <PrivateRoute path="/employee-effectiveness/:id" component={EmployeeEffectivenessDetail} resource='customUser' exact/>
              <PrivateRoute path="/partner-effectiveness" component={PartnerEffectiveness} resource='partner' exact/>
              <PrivateRoute path="/partner-effectiveness/:id" component={PartnerEffectivenessDetail} resource='partner' exact/>
              <PrivateRoute path="/partner-compare/:first/:second" component={PartnerCompare} resource='partner' exact/>
              <PrivateRoute path="/group-compare/:first/:second" component={GroupCompare} resource='partner' exact/>
              <PrivateRoute path="/partner-traffic-effectiveness" component={PartnerTrafficEffectiveness} resource='partner' exact/>
              <PrivateRoute path="/partner-traffic-effectiveness/:id" component={PartnerTrafficEffectivenessDetail} resource='partner' exact/>
              {/*<PrivateRoute path="/test" component={TestPage} exact/>*/}

              <PrivateRoute path="/change-password" component={ChangePassword} resource={null} exact/>

              <Route path="/login" component={Login} exact/>

              <Route component={NotFound}/>
            </Switch>
          </AuthProvider>
        </Router>
      </ErrorProvider>
    </ConfigProvider>
  </ThemeProvider>
}

export default App;